import { Toast, ToastMessage } from "primereact/toast";
import React, { useEffect, useRef } from "react";

const GLOBAL_ALERT_EVENT_NAME = "EasasGlobalAlertEvent";

export default function EasasGlobalAlerts() {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    const listener = (e: EasasGlobalAlertEvent) => {
      toastRef.current?.replace({
        life: 6000,
        severity: "info",
        ...e.detail,
      });
    };

    window.addEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener);
    return () => window.removeEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener);
  }, []);

  return <Toast ref={toastRef} style={{ top: "60px" }} />;
}

export function easasAlert(toastMessage: string | ToastMessage) {
  typeof toastMessage === "string"
    ? dispatchEvent(new EasasGlobalAlertEvent({ summary: toastMessage }))
    : dispatchEvent(new EasasGlobalAlertEvent({ ...toastMessage }));
}

export function easasSuccessAlert(detail: string) {
  easasAlert({
    summary: "Success",
    detail,
    severity: "success",
    life: 3000,
  });
}

export function easasErrorAlert(detail: string) {
  easasAlert({
    summary: "Error",
    detail,
    severity: "error",
    life: 3000,
  });
}

class EasasGlobalAlertEvent extends CustomEvent<ToastMessage> {
  constructor(msg: ToastMessage) {
    super(GLOBAL_ALERT_EVENT_NAME, { detail: msg });
  }
}
